<div fxLayout="row" fxLayoutAlign="center" class="mt-2">
  <div fxFlex="100" fxFlex.gt-sm="1 1 400px" fxFlex.sm="1 1 400px" class="mat-elevation-z6">

    <div class="flex-row-container m-3 p-3" *ngIf="appointment">
      <!-- <div style="word-wrap: break-word;">{{diagnostic}}</div> -->

      <h1 *ngIf='appointment.EventID === 0'>{{ 'FIND-TIME.CREATE-APPOINTMENT' | translate }}</h1>
      <h1 *ngIf='appointment.EventID > 0'>{{ 'FIND-TIME.MOVE-APPOINTMENT' | translate}}</h1>

      <form class="flex-row-container" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">

        <div fxLayout="column" fxLayoutAlign="space-evenly">
          <span><b>{{ 'COMMON.PATIENT-NAME' | translate }}:</b> {{ patientName }}</span>
          <span><b>{{ 'COMMON.AGE' | translate }}:</b> {{ age }} </span>
          <span><b>{{ 'COMMON.GENDER' | translate }}:</b> {{ gender }} </span>
          <span>
            <b>{{ 'COMMON.VISIT-REASON' | translate }}:</b>
            <div>
                <div *ngFor="let summary of visitSummary">
                    {{ summary }} 
                  </div>
            </div>
          </span>
          <span><b>{{ 'COMMON.MOBILE-PHONE' | translate }}:</b> {{ phone }} </span>
          <span><b>{{ 'COMMON.THERAPIST' | translate }}:</b> {{ schedulerName }} | {{branchName}} </span>
          <span *ngIf="roomName && appointment.EventID === 0"><b>{{ 'COMMON.ROOM' | translate }}:</b> {{roomName}} </span>
          <span><b>{{ 'COMMON.DATE-AND-TIME' | translate }}:</b>&nbsp;
            <span><b></b>{{ start | amDateFormat: 'ddd' }}</span>
            <span style="margin:0 5px;">|</span>
            <span>{{ start | amDateFormat: 'L' }}</span>
            <span style="margin:0 5px;">|</span>
            <span>{{ start | amDateFormat: 'LT'}}-{{ end | amDateFormat: 'LT'}}</span>
          </span>
          <span><b> {{ 'COMMON.DURATION' | translate }}: </b> {{ duration }} {{ 'TIME.MINS' | translate }}</span>
        </div>

        <mat-form-field>
          <mat-label>{{ 'COMMON.PRICE' | translate }}</mat-label>
          <input matInput type="number" placeholder="0.00" formControlName="price"
            (blur)="toDecimal($event.target.value)">
          <!-- <mat-error *ngIf="form.controls.password.errors?.required">{{ 'LOGIN.PASSWORD-REQUIRED' | translate }}</mat-error>-->
          <mat-error *ngIf="form.controls.price.hasError('min')">{{ 'ERROR.MINPRICE' | translate: { 'min': '0'} }}
          </mat-error>
          <mat-error *ngIf="form.controls.price.hasError('max')">{{ 'ERROR.MAXPRICE' | translate: { 'max': '99,999'} }}
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="appointment.EventID > 0">
          <mat-label *ngIf="isRoomRequired">{{ 'SCHEDULER.SELECT-ROOM' | translate }} <span class="accent-color">*</span></mat-label>
          <mat-select placeholder="{{ 'COMMON.ROOM' | translate }}" formControlName="room">
            <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
            <mat-option *ngFor="let currentRoom of rooms" [value]="currentRoom.ID">
              {{currentRoom.Name}} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'COMMON.NOTE' | translate }}</mat-label>
          <textarea matInput cdkTextareaAutosize placeholder="{{ 'COMMON.NOTE' | translate }}" formControlName="note"
            maxlength="256" ></textarea>
          <mat-error *ngIf="form.controls.note.errors?.maxlength">{{ 'ERROR.MAXLENGTH' | translate: { length: 256} }}
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="{{ 'COMMON.LABEL' | translate }}" formControlName="selectedColor">
            <mat-select-trigger>
              <span *ngIf="form.get('selectedColor').value" class="round" [style.background-color]="form.get('selectedColor').value.Background"></span>
              {{ form.get('selectedColor').value ? form.get('selectedColor').value.Name : 'bb'}}
            </mat-select-trigger>
            <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
            <mat-option *ngFor="let label of labels" [value]="label">
              <span class="round"
                [style.background-color]="label.Background"></span>&nbsp;{{label.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        

        <div fxLayout="row" fxLayoutGap="20px">
          <mat-checkbox formControlName="sms">SMS</mat-checkbox>
          <mat-checkbox formControlName="email">Email</mat-checkbox>
          <mat-checkbox formControlName="whatsapp" *ngIf="isWhatsAppEnabled">WhatsApp</mat-checkbox>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center">
          <div style="position: relative;">
            <select id="confirmed" class="d-checkbox" 
            [class.ic-ok]="f.confirmed.value === confirmeAppointmentType.Confirmed"
            [class.confirmed-online]="f.confirmed.value === confirmeAppointmentType.ConfirmedOnlineByPatient"
            [class.decline]="f.confirmed.value === confirmeAppointmentType.Decline"           
            formControlName="confirmed">
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
            <label for="confirmed" class="d-checkbox-label" (click)="onClick_markApptAs($event)">
              <span class="ic-large ic-ok"></span>
              <span class="ic-small ic-ok"></span>
              <span class="alert-text">{{ 'COMMON.CONFIRMED' | translate}}</span>
            </label>
          </div>
          <!-- <div style="position: relative;">
            <input id="confirmed" class="d-checkbox" type="checkbox" formControlName="confirmed">
            <label for="confirmed" class="d-checkbox-label">
              <span class="ic-large ic-ok"></span>
              <span class="ic-small ic-ok"></span>
              <span class="alert-text">{{ 'COMMON.CONFIRMED' | translate}}</span>
            </label>
          </div> -->
          <div style="position: relative;">
            <input id="arrived" class="d-checkbox" type="checkbox" formControlName="arrived">
            <label for="arrived" class="d-checkbox-label">
              <span class="ic-large ic-arrived"></span>
              <span class="ic-small ic-arrived"></span>
              <span class="alert-text">{{ 'COMMON.ARRIVED' | translate}}</span>
            </label>
          </div>
          <div style="position: relative;">
            <input id="noShow" class="d-checkbox" type="checkbox" formControlName="noShow">
            <label for="noShow" class="d-checkbox-label">
              <span class="ic-large ic-d-show"></span>
              <span class="ic-small ic-d-show"></span>
              <span class="alert-text">{{ 'COMMON.NO-SHOW' | translate}}</span>
            </label>
          </div>
          <div style="position: relative;">
            <input id="paid" class="d-checkbox" type="checkbox" formControlName="paid">
            <label for="paid" class="d-checkbox-label">
              <span class="ic-large ic-paid"></span>
              <span class="ic-small ic-paid"></span>
              <span class="alert-text">{{ 'COMMON.PAID' | translate}}</span>
            </label>
          </div>
        </div>


        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center">


          <button mat-raised-button color="accent" class="mat-elevation-z6  mt-3" type="submit"
            [disabled]="!(form.valid && (hasIdNumber || !isIdNumberRequired))">{{
          'COMMON.SAVE' | translate }}</button>

          <button mat-raised-button class="mat-elevation-z6  mt-3" (click)="onCancel($event)">{{
            'COMMON.CANCEL' | translate }}</button>

        </div>

        <mat-error *ngIf="error" class="alert alert-danger">{{error}}</mat-error>
      </form>
    </div>

  </div>
</div>
